import React, { useState } from 'react'
import { FormattedNumber } from 'react-intl'
import { MagentoMoney, MagentoCartTaxItem } from 'lib/types'
import { ReactComponent as ChevronDown } from 'lib/core/resources/svg/chevron-down.svg'
import { BLANK_SPACE } from 'lib/core/resources/constants'
import { Price } from 'lib/shared'

interface Props {
  appliedTaxes: MagentoCartTaxItem[]
  subtotalExcludingTax: MagentoMoney
  subtotalIncludingTax: MagentoMoney
}

export const Tax: React.FC<Props> = ({
  appliedTaxes,
  subtotalExcludingTax,
  subtotalIncludingTax
}) => {
  const [isDetailVisible, setIsDetailVisible] = useState(false)
  const priceSubtotal = getTaxSubtotal(subtotalExcludingTax, subtotalIncludingTax)
  return (
    <>
      <tr
        className={isDetailVisible ? 'tax-row tax-row--visible' : 'tax-row'}
        onClick={() => setIsDetailVisible(!isDetailVisible)}
      >
        <th>Tax</th>
        <td>
          <span>
            <Price
              {...priceSubtotal}
            />
            <ChevronDown />
          </span>
        </td>
      </tr>
      {appliedTaxes?.map(tax => {
        const { label, amount } = tax
        const percentage = getPrice(amount) / getPrice(subtotalExcludingTax)

        return isDetailVisible && (
          <tr className='tax-details'>
            <th>
              {label}
              {BLANK_SPACE}
              (
              <FormattedNumber
                style='percent' // eslint-disable-line
                maximumFractionDigits={1}
                value={percentage}
              />
              )
            </th>
            <td>
              <Price
                {...amount}
              />
            </td>
          </tr>
        )
      })}
    </>
  )
}

const getTaxSubtotal = (subtotalExcludingTax: MagentoMoney, subtotalIncludingTax: MagentoMoney) => {
  const value = getPrice(subtotalIncludingTax) - getPrice(subtotalExcludingTax)
  return {
    value,
    currency: subtotalExcludingTax.currency
  }
}

const getPrice = ({ value }: MagentoMoney) => {
  return value
}
